<template>
  <div v-if="productsData ">
    <transition name="slide">
      <div class="myapp-wrapper" v-if="widgetVisible">
        <div class="myapp">
          <div class="myapp-title">
            <h2>{{ i18n.recommended_products }}</h2>
            <a :href="listingUrl">{{ i18n.see_all }} ></a>
          </div>
          <swiper class="swiper" :options="swiperOptions">
            <swiper-slide v-for="(product, index) in productsData" :key="index">
                <SliderBuyOnlineSingleBox :product="product" :i18n="component_data.i18n"></SliderBuyOnlineSingleBox>
            </swiper-slide>
          </swiper>
          <div class="nav-container">
            <div class="swiper-prev">
              <svg
                style="width:17px;height:34px;fill:none;stroke:#D4D4D4;stroke-width: 2px;"
                viewBox="0 0 17 34"
              >
                <path d="M17 0 L0 17 L17 34" />
              </svg>
            </div>
            <div class="swiper-next">
              <svg
                style="width:17px;height:34px;fill:none;stroke:#D4D4D4;stroke-width: 2px;"
                viewBox="0 0 17 34"
              >
                <path d="M0 0 L17 17 L0 34" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <SliderBuyOnlineButton
      :handlerText="handlerText"
      :widgetVisible="widgetVisible"
         :i18n="component_data.i18n"
      @click-toggle="toggleWidgetVisibility"
    />
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SliderBuyOnlineSingleBox from "./SliderBuyOnlineSingleBox";
import SliderBuyOnlineButton from "./SliderBuyOnlineButton";


export default {
  props: ["widget", 'component_data'],


  data() {
    return {
      see_all: "Zobacz wszystkie",
      widgetVisible: false,
      handlerText: this.component_data.i18n.buy_online,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 1000,
        breakpoints: {
          1700: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesPerGroup: 3,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 10,
            slidesPerGroup: 3,
          },
          1250: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2,
          },
          980:{
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 2,
          }
        },
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
      },
    };
  },

  computed: {
    productsData() {
     if (this.component_data && this.component_data.recommendedProducts && this.component_data.recommendedProducts.length ) {
       return this.component_data.recommendedProducts;
     } else {
       return window.pageContentData.params.recommendedProducts;
     }
    },
    listingUrl: function() {
       return this.component_data.listingUrl;
    },
    i18n() {
     return this.component_data.i18n;
    },
  },
  components: {
    SliderBuyOnlineSingleBox,
    Swiper,
    SwiperSlide,
    SliderBuyOnlineButton,
  },
  methods: {
    toggleWidgetVisibility: function() {
   
      this.widgetVisible = !this.widgetVisible;
    
      if (this.widgetVisible) {
        this.handlerText = this.i18n.close;
      } else {
        this.handlerText = this.i18n.buy_online;
      }
    },
  },
};
</script>
<style> 
.myapp-wrapper .swiper-wrapper {
    align-items: flex-end;
}
</style>
<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  animation: myfirst 0.4s;
  animation-direction: ease-in;
}
.slide-leave-to {
  animation: myfirst-out 0.4s;
  animation-direction: ease-in;
}
@keyframes myfirst {
  0% {
    right: 0px;
    left: 100vw;
  }
  100% {
    right: 100vw;
    left: 0px;
  }
}
@keyframes myfirst-out {
  0% {
    right: 100vw;
    left: 0px;
  }
  100% {
    right: 0px;
    left: 100vw;
  }
}
.myapp-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  .myapp-title {
    margin-bottom: 55px;
       @media screen and (max-width: 1400px) {
       margin-bottom: 15px;        
    }
    h2 {
      font-size: 48px;
      line-height: 150%;
      font-weight: bold;
      @media screen and (max-width: 1400px) {
      font-size: 36px;
      line-height: 120%;
      padding-top: 2rem;
}
         
    }
    a {
      color: #e41429;
      font-size: 16px;
    }
  }
}
.myapp {
  width: 1260px;
  margin: auto;

  .nav-container {
    .swiper-prev {
      position: absolute;
      left: 10%;
      top: 50%;
      cursor: pointer;
    }
    .swiper-next {
      position: absolute;
      right: 10%;
      top: 50%;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 1700px) {
  .myapp {
    width: 1060px;
  }
}
@media screen and (max-width: 1400px) {
  .myapp {
    width: 960px;
  }
  .swiper-container{
    margin-bottom: -2rem;
  }
}
@media screen and (max-width: 1250px) {
  .myapp {
    width: 760px;
  }
}



</style>
